import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ExpandableHtml } from '@bibliocommons/expandable';

export default class MediaSummary extends React.PureComponent {
  render() {
    if (!this.props.mediaSummary) return null;
    return (
      <div className="cp-media-summary">
        <FormattedMessage tagName="h3" id="media_summary" />
        <ExpandableHtml
          htmlText={this.props.mediaSummary}
          expandLinkHref="#media-summary-read-more"
          dataKey="media-summary-read-more-link"
          textKey="media_summary"
        />
      </div>
    );
  }
}

MediaSummary.propTypes = {
  mediaSummary: PropTypes.string
};
